// extracted by mini-css-extract-plugin
module.exports = {"field":"PropertiesField_field__bnOlH"};